import { TenantDto } from '@careapp-group/ng-sdk-v2-new';
import { CareAppListActionFactory } from '../action-factory';

class TenantsActions extends CareAppListActionFactory<TenantDto> {
  constructor(modelName: string) {
    super(modelName);
  }
}

export const Tenants = new TenantsActions(`Tenants`);
